import React from 'react';
import '../less/calculator.less';
import CreditLine from './creditLine';
import CreditVygoda from './creditVygoda';
import CreditCards from './creditCards';
import CreditQuickCash from './creditQuickCash';
import CreditQuickCashBusiness from './creditQuickCashBusiness';
import InstallmentFromStatement from './installmentFromStatement';
import PayByParts from './payByParts';
import InstallmentFromStatementPbp from './installmentFromStatementPbp';
import PbpEntity from './pbpEntity';
import CreditLimit from './creditLimit';
import Aexpress from './aexpress';
import BusinessDeposits from './businessDeposits';
import ExpressEnergy from './expressEnergy';

export default function template() {
    const type = this.props.type,
        newPart = {
          ["credline"]: <CreditLine calc={this} />,
          ["pbp_entity"]: <PbpEntity calc={this} />,
          ["quick_cash"]: <CreditQuickCash calc={this} />,
          ["quick_cash_business"]: <CreditQuickCashBusiness calc={this} />,
          ["credit_vygoda"]: <CreditVygoda calc={this} />,
          ["credit_cards"]: <CreditCards calc={this} />,
          ["installment_from_statement"]: <InstallmentFromStatement calc={this} />,
          ["payment_part"]: <PayByParts calc={this} />,
          ["installment_plan"]: <InstallmentFromStatementPbp calc={this} />,
          ["limit"]: <CreditLimit calc={this} />,
          ["aexpress"]: <Aexpress calc={this} />,
          ["business_deposits"]: <BusinessDeposits calc={this} />,
          ["express-energy"]: <ExpressEnergy calc={this} />
        }

    return (
        <div className={`calculator-new ${type}`}>
          <div className="calculator-new__body">
            <div className="calculator-new__content">
              {newPart[type]}
            </div>
          </div>
        </div>
    );
}
